import {
  AnimationComponent,
  Divider,
  Grid2,
  Show,
  Tab,
  Tabs,
} from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useState } from "react";
import axiosInstance from "utils/axiosInstance";
import useDocumentTitle from "utils/useDocumentTitle";
import EmailHeaderSection from "../EmailHeaderSection";
import SmtpSetup from "../SmtpSetup";
import EmailTemplates from "./EmailTemplates";

const EmailTemplateConfig = () => {
  useDocumentTitle("Email Configuration");

  const [tab, setTab] = useState(0);

  const { data, refetch } = useFetchQuery({
    key: ["EMAIL_CONFIGURATION"],
    route: "/email-configuration/",
  });

  const { mutate: handleUpdateEmailConfig, isLoading: emailConfigLoading } =
    useMutation({
      mutationKey: ["HANDLE_UPDATE_EMAIL_CONFIGURATION"],
      mutationFn: (values: any) =>
        axiosInstance.patch(
          `/email-configuration-header/${data?.data?.data?.id}/`,
          values,
        ),
      onSuccess: () => {
        refetch();
      },
    });

  const tabs = [
    {
      label: "SMTP Setup",
      component: <SmtpSetup />,
    },
    {
      label: "General Settings",
      component: (
        <EmailHeaderSection
          data={data?.data?.data}
          handleUpdate={handleUpdateEmailConfig}
          isLoading={emailConfigLoading}
        />
      ),
    },
    {
      label: "Email Templates",
      component: <EmailTemplates />,
    },
  ];

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12} display={"flex"} flexDirection={"column"}>
        <Tabs
          sx={{
            "& .MuiTabs-flexContainer": {
              backgroundColor: "var(--white)",
            },
          }}
          onChange={(e, val) => setTab(val)}
          value={tab}
        >
          {tabs?.map((tab, index) => (
            <Tab key={index} label={tab.label} disableRipple />
          ))}
        </Tabs>
        <Divider />
      </Grid2>
      <Grid2 size={12} mt={1}>
        {tabs.map((tabItem, index) => (
          <Show.When key={index} isTrue={tab === index}>
            <AnimationComponent>{tabItem.component}</AnimationComponent>
          </Show.When>
        ))}
      </Grid2>
    </Grid2>
  );
};

export default EmailTemplateConfig;
